import store from '../store'

function importLayouts (view) { // Lazy Loading Route
  return (resolve) => import(
    `@/views/layouts/${view}.vue`
  ).then(resolve)
}

function importPages ({ subFolder = null, view }) {
  if (subFolder) {
    return (resolve) => import(
      `@/views/${subFolder}/${view}.vue`
    ).then(resolve)
  }

  return (resolve) => import(
    `@/views/${view}.vue`
  ).then(resolve)
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.authorized) {
    next()
    return
  }

  next('/')
}

/* Main layouts */
const mainContainer = importLayouts('AppMain')
const loginContainer = importLayouts('AppLogin')

/* Main views */

// const awardView = importPages({ subFolder: 'setup', view: 'Award' })
const branchView = importPages({ subFolder: 'setup', view: 'Branch' })
// const departmentView = importPages({ subFolder: 'setup', view: 'Department' })
const employeeManagementView = importPages({ subFolder: 'organization', view: 'employee/Index' })
// HRIS
const holidayView = importPages({ subFolder: 'setup', view: 'Holiday' })
const holidayDetailsView = importPages({ subFolder: 'setup', view: 'HolidayDetails' })
// const jobDescriptionView = importPages({ subFolder: 'setup', view: 'JobDescription' })
const kpiCategoryView = importPages({ subFolder: 'setup', view: 'KpiCategory' })
// const kpiChartView = importPages({ subFolder: 'kpichart', view: 'Index' })
const loginView = importPages({ subFolder: 'auth', view: 'Index' })
// const leaveEntitlementView = importPages({ subFolder: 'setup', view: 'LeaveEntitlement' })
// const leaveApplicationView = importPages({ subFolder: 'leave', view: 'LeaveApplication' })
// const leaveDashboardView = importPages({ subFolder: 'leave', view: 'LeaveDashboard' })
// const leaveTypeView = importPages({ subFolder: 'setup', view: 'LeaveType' })
// const myLeaveView = importPages({ subFolder: 'leave', view: 'MyLeave' })
// const orgChartView = importPages({ subFolder: 'orgchart', view: 'Index' })
const permissionView = importPages({ view: 'NoPermission' })
// const positionView = importPages({ subFolder: 'setup', view: 'Position' })
const promiseRequestView = importPages({ subFolder: 'promise', view: 'PromiseRequest' })
// const rankView = importPages({ subFolder: 'setup', view: 'Rank' })
const roleView = importPages({ subFolder: 'setup', view: 'Role' })
// const skillCategoryView = importPages({ subFolder: 'setup', view: 'SkillCategory' })
const taskCategoryView = importPages({ subFolder: 'setup', view: 'TaskCategory' })
const taskPriorityView = importPages({ subFolder: 'setup', view: 'TaskPriority' })
// const skillView = importPages({ subFolder: 'setup', view: 'Skill' })
// HRIS
// const separationTypeView = importPages({ subFolder: 'setup', view: 'SeparationType' })
const tagView = importPages({ subFolder: 'setup', view: 'Tag' })
const userProfileView = importPages({ subFolder: 'user', view: 'Profile' })
const taskView = importPages({ subFolder: 'task', view: 'Task' })
const classroomTypeView = importPages({ subFolder: 'setup', view: 'ClassroomType' })
const courseCategoryView = importPages({ subFolder: 'setup', view: 'CourseCategory' })
const courseView = importPages({ subFolder: 'setup', view: 'Course' })
const courseMaterialTypeView = importPages({ subFolder: 'setup', view: 'CourseMaterialType' })
const myCourseView = importPages({ subFolder: 'setup', view: 'MyCourse' })
const notificationTypeView = importPages({ subFolder: 'setup', view: 'NotificationType' })
// const leaveEntitlementSettingView = importPages({ subFolder: 'setup', view: 'LeaveEntitlementSetting' })
// const leaveReportView = importPages({ subFolder: 'setup', view: 'LeaveReport' })
// const attendanceSettingView = importPages({ subFolder: 'setup', view: 'AttendanceSetting' })
const officeLocationView = importPages({ subFolder: 'setup', view: 'OfficeLocation' })
// const attendanceReportView = importPages({ subFolder: 'setup', view: 'AttendanceReport' })
// HRIS
// const workSessionTypeView = importPages({ subFolder: 'setup', view: 'WorkSessionType' })
const announcementSetupView = importPages({ subFolder: 'setup', view: 'Announcement' })
const announcementView = importPages({ subFolder: 'newsletter', view: 'Announcement' })
const announcementCategorySetupView = importPages({ subFolder: 'setup', view: 'AnnouncementCategory' })
const jobBandSetupView = importPages({ subFolder: 'setup', view: 'JobBand' })
const jobCategorySetupView = importPages({ subFolder: 'setup', view: 'JobCategory' })
const jobGroupSetupView = importPages({ subFolder: 'setup', view: 'JobGroup' })
const jobGradeSetupView = importPages({ subFolder: 'setup', view: 'JobGrade' })
// const fileManagerSetupView = importPages({ subFolder: 'setup', view: 'FileManager' })
const attendanceImportView = importPages({ subFolder: 'attendance', view: 'Attendance' })
const myAttendanceView = importPages({ subFolder: 'attendance', view: 'MyAttendance' })
const qualityManagementFolder = importPages({ subFolder: 'setup', view: 'QualityManagementFolder' })
const myQualityManagement = importPages({ subFolder: 'setup', view: 'MyQualityManagement' })
const eventManagement = importPages({ view: 'EventManagement' })
const qualityManagement = importPages({ subFolder: 'setup', view: 'QualityManagement' })

export default [
  { // catch-all route
    path: '*',
    redirect: {
      path: '/profile',
    },
  },
  { // default route
    path: '/',
    redirect: {
      path: '/profile',
    },
  },
  {
    path: '/login',
    component: loginContainer,
    beforeEnter: ifNotAuthenticated, // Per-Route Guard
    children: [
      {
        path: '',
        name: 'login',
        component: loginView,
      },
    ],
  },
  {
    path: '',
    component: mainContainer,
    meta: {
      name: '',
      requiresAuth: true,
    },
    children: [
      {
        path: '/permissions/deny',
        name: 'Permission Denied',
        component: permissionView,
        meta: {
          requiresAuth: true,
        },
      },

      /* Public */
      {
        path: '/profile',
        name: 'Profile',
        component: userProfileView,
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: '/my-leave',
      //   name: 'My Leave Management',
      //   component: myLeaveView,
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      {
        path: '/my-course',
        name: 'My Courses',
        component: myCourseView,
        meta: {
          requiresAuth: true,
        },
      },
      // {
      //   path: '/orgchart',
      //   name: 'Organization Chart',
      //   component: orgChartView,
      //   meta: { 
      //     requiresAuth: true,
      //   },
      // },
      // {
      //   path: '/kpichart/:id?',
      //   name: 'KPI Chart',
      //   component: kpiChartView,
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },

      /* Organization */
      {
        path: '/branches',
        name: 'Branch Management',
        component: branchView,
        meta: {
          requiresAuth: true,
          permission: 'setup branch view',
        },
      },
      {
        path: '/employees',
        name: 'Employee Management',
        component: employeeManagementView,
        meta: { 
          requiresAuth: true,
          permission: 'organization employee view',
        },
      },
      // {
      //   path: '/leave-applications',
      //   name: 'Leave Applications Management',
      //   component: leaveApplicationView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'leave application view',
      //   },
      // },
      {
        path: '/promises',
        name: 'Promise Requests',
        component: promiseRequestView,
        meta: {
          requiresAuth: true,
          permission: 'update promises',
        },
      },
      // {
      //   path: '/leave-dashboard',
      //   name: 'Leave Dashboard',
      //   component: leaveDashboardView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'leave dashboard view',
      //   },
      // },
      {
        path: '/tasks/:id?',
        name: 'Task Management',
        component: taskView,
        meta: { 
          requiresAuth: true,
        },
    },

      /* Setup */
      // {
      //   path: '/awards',
      //   name: 'Award Management',
      //   component: awardView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'setup award view',
      //   },
      // },
      // HRIS
      // {
      //   path: '/departments',
      //   name: 'Department Management',
      //   component: departmentView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup department view',
      //   },
      // },
      {
        path: '/holidays',
        name: 'Holiday Management',
        component: holidayView,
        meta: {
          requiresAuth: true,
          permission: 'setup holiday view',
        },
      },
      {
        path: '/holiday-details',
        name: 'Holiday Details Management',
        component: holidayDetailsView,
        meta: {
          requiresAuth: true,
          permission: 'setup holiday view',
        },
      },
      // {
      //   path: '/job-descriptions',
      //   name: 'Job Description Management',
      //   component: jobDescriptionView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup job description view',
      //   },
      // },
      {
        path: '/kpi-categories',
        name: 'Kpi Category Management',
        component: kpiCategoryView,
        meta: { 
          requiresAuth: true,
          permission: 'setup kpi category view',
        },
      },
      // {
      //   path: '/leave-entitlements',
      //   name: 'Leave Entitlement Management',
      //   component: leaveEntitlementView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'setup leave entitlement view',
      //   },
      // },
      // {
      //   path: '/leave-entitlement-settings',
      //   name: 'Leave Entitlement Settings Management',
      //   component: leaveEntitlementSettingView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'setup leave entitlement setting view',
      //   },
      // },
      // {
      //   path: '/leave-types',
      //   name: 'Leave Type Management',
      //   component: leaveTypeView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup leave type view',
      //   },
      // },
      
      // {
      //   path: '/positions',
      //   name: 'Position Management',
      //   component: positionView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup position view',
      //   },
      // },
      // {
      //   path: '/ranks',
      //   name: 'Rank Management',
      //   component: rankView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup rank view',
      //   },
      // },
      {
        path: '/roles',
        name: 'Role Management',
        component: roleView,
        meta: { 
          requiresAuth: true,
          permission: 'setup role view',
        },
      },
      // {
      //   path: '/skills',
      //   name: 'Skill Management',
      //   component: skillView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup skill view',
      //   },
      // },
      // {
      //   path: '/skill-categories',
      //   name: 'Skill Category Management',
      //   component: skillCategoryView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup skill category view',
      //   },
      // },
      {
        path: '/task-categories',
        name: 'Task Category Management',
        component: taskCategoryView,
        meta: { 
          requiresAuth: true,
          permission: 'setup task category view',
        },
      },
      {
        path: '/task-priorities',
        name: 'Task Priorities Management',
        component: taskPriorityView,
        meta: { 
          requiresAuth: true,
          permission: 'setup task priority view',
        },
      },
      // HRIS
      // {
      //   path: '/separation-types',
      //   name: 'Separation Type Management',
      //   component: separationTypeView,
      //   meta: { 
      //     requiresAuth: true,
      //     permission: 'setup separation type view',
      //   },
      // },
      {
        path: '/tags',
        name: 'Tag Management',
        component: tagView,
        meta: { 
          requiresAuth: true,
          permission: 'setup tag view',
        },
      },
      {
        path: '/classroom-types',
        name: 'Classroom Type Management',
        component: classroomTypeView,
        meta: {
          requiresAuth: true,
          permission: 'setup classroom type view',
        },
      },
      {
        path: '/course-categories',
        name: 'Course Categories Management',
        component: courseCategoryView,
        meta: {
          requiresAuth: true,
          permission: 'setup course category view',
        },
      },
      {
        path: '/courses',
        name: 'Course Management',
        component: courseView,
        meta: {
          requiresAuth: true,
          permission: 'setup course view',
        },
      },
      {
        path: '/course-material-types',
        name: 'Course Material Types',
        component: courseMaterialTypeView,
        meta: {
          requiresAuth: true,
          permission: 'setup course material type view',
        }, 
      },
      {
        path: '/notification-types',
        name: 'Notification Type Management',
        component: notificationTypeView,
        meta: {
          requiresAuth: true,
          permission: 'setup notification type view',
        },
      },
      // {
      //   path: '/leave-reports',
      //   name: 'Leave Reports',
      //   component: leaveReportView,
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
      // {
      //   path: '/attendance',
      //   name: 'Attendance Settings',
      //   component: attendanceSettingView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'attendance setting view',
      //   },
      // },
      {
        path: '/office-locations',
        name: 'Office Locations',
        component: officeLocationView,
        meta: {
          requireAuth: true,
          permission: 'setup office location view',
        },
      },
      // {
      //   path: '/attendance-reports',
      //   name: 'Attendance Reports',
      //   component: attendanceReportView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'attendance report view',  
      //   },
      // },
      // HRIS
      // { 
      //   path: '/work-session-types',
      //   name: 'Work Session Types',
      //   component: workSessionTypeView,
      //   meta: {
      //     requiresAuth: true,
      //     permission: 'setup work session types view',  
      //   },
      // },
      {
        path: '/announcement-setup',
        name: 'Announcements',
        component: announcementSetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup announcement view',
          },
      },
      {
        path: '/announcements/:id?',
        name: 'Announcements',
        component: announcementView,
        meta: { 
          requiresAuth: true,
          },
        },
      {
        path: '/announcement-categories',
        name: 'Category',
        component: announcementCategorySetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup announcement category view',
          },
      },
      {
        path: '/job-bands',
        name: 'Job Bands',
        component: jobBandSetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup job band view',
          },
      },
      {
        path: '/job-categories',
        name: 'Job Categories',
        component: jobCategorySetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup job category view',
          },
      },
      {
        path: '/job-groups',
        name: 'Job Groups',
        component: jobGroupSetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup job group view',
          },
      },
      {
        path: '/job-grades',
        name: 'Job Grades',
        component: jobGradeSetupView,
        meta: { 
          requiresAuth: true,
            permission: 'setup job grade view',
        },
      },
      // {
      //   path: '/documents',
      //   name: 'File & Templates',
      //   component: fileManagerSetupView,
      //   meta: { 
      //     requiresAuth: true,
      //     },
      // },
      {
        path: '/attendances',
        name: 'Attendance Import',
        component: attendanceImportView,
        meta: { 
          requiresAuth: true,
            permission: 'attendance import view',
          },
      },
      {
        path: '/my-attendance',
        name: 'My Attendance',
        component: myAttendanceView,
        meta: {
          requiresAuth: true,
          // permission: 'setup job grade view', //yaw
        },
      },
      {
        path: '/qm-folder',
        name: 'Quality Management Folder',
        component: qualityManagementFolder,
        meta: { 
          requiresAuth: true,
            permission: 'setup quality management folder view',
          },
      },
      {
        path: '/my-quality-management',
        name: 'Quality Management',
        component: myQualityManagement,
        meta: { 
          requiresAuth: true,
          },
      },
      {
        path: '/events',
        name: 'Events',
        component: eventManagement,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/quality-managements',
        name: 'Quality Management',
        component: qualityManagement,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
